/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');
require('./main/breadcrumbs');
require('./main/navbar');
require('./main/nav-primary');
require('./main/gsap');
require('./main/sort-field');
require('./main/results-count');
require('./main/alert-bar');
require('./main/popup');
require('./main/category-badge');

import domReady from '@wordpress/dom-ready';

domReady(() => {
  console.log('Dom is ready');
});
